<div class="flex flex-col sm:flex-row gap-3">
  <div class="flex-1 space-y-1">
    <div class="text-xs text-gray-500">Policy</div>
    <vs-select
      vsInput
      [value]="selectedPolicyId"
      [config]="{ placeholder: 'Select a policy...' }"
      [disabled]="loading || policies.length === 0"
      (valueChanges)="onPolicyChange($event)"
    >
      <li *ngFor="let policy of policies" vs-select-option [value]="policy.id">
        {{ policy.title }} ({{ policy.policyNumber }})
      </li>
    </vs-select>
  </div>

  <div class="flex-1 space-y-1">
    <div class="text-xs text-gray-500">Plan</div>
    <vs-select
      vsInput
      [value]="selectedPlanId"
      [config]="{ placeholder: 'Select a plan...' }"
      [disabled]="!selectedPolicy"
      (valueChanges)="onPlanChange($event)"
    >
      <li *ngFor="let plan of selectedPolicy?.plans ?? []" vs-select-option [value]="plan.id">
        {{ plan.title }}
      </li>
    </vs-select>
  </div>
</div>

<div *ngIf="error" class="text-xs text-danger-500 mt-2">
  Couldn't load commission-eligible policies. Try refreshing the page.
</div>

<div *ngIf="!loading && !error && policies.length === 0" class="text-xs text-gray-400 italic mt-2">
  No commission-eligible policies found for this distributor.
</div>
